import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
// import { OrderHistoryColumns } from '../../../Data/MockTable/TableHeaderList';
import SweetAlert from "sweetalert2";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { deleteAccount, getAccount } from "../../CommonURL";
import { postDataWithToken } from "../../Utils/restUtils";
import { Add ,Filter,PaymentStatus} from "../../Constant";
import SearchList from "../../CommonElements/Search";
import SearchFilter from "../Common/Filters/Search";
import IndustryFilter from "../Common/Filters/IndustryFilter";
import { useForm } from "react-hook-form";
import CompanyFilter from "../Common/Filters/CompanyFilter";
import { invoicePaymentOptions } from "../../Constant/DropdownValue";
import DatePicker from "react-datepicker";

// import Transparentspinner from '../../Common/loader/Transparentspinner';

const ExpiredSubscriptions = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const navigate = useNavigate();
  const location = useLocation();
  const isStatus = useRef(null);
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const sortedBy = params.get("sortBy") || "";
  const sortedOrder = params.get("sortOrder") || "";
  const company_id_param = params.get("company_id") || "";
  const industry_id_param = params.get("industry_id") || "";
  const [filters, setFilters] = useState({
    search: params.get("search") || "",
    status: params.get("status") || "",
    companyId: params.get("companyId")
      ? Number(params.get("companyId"))
      : company_id_param
        ? Number(company_id_param)
        : "",
    industryId: params.get("industryId") || industry_id_param || "",
    start_date: params.get("start_date")
      ? moment(params.get("start_date"), "DD-MM-YYYY").toDate()
      : "",
    end_date: params.get("end_date")
      ? moment(params.get("end_date"), "DD-MM-YYYY").toDate()
      : "",
  });
   const [dateRange, setDateRange] = useState([
      filters.start_date,
      filters.end_date,
    ]);
    const [startDate, endDate] = dateRange;
    const [invoiceList, setInvoiceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [orderId, setOrderId] = useState("");
    const [modal, setModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({
      column: sortedBy,
      order: sortedOrder,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [isIndustry, setIsIndustry] = useState(null);
    const [isCompany, setIsCompany] = useState(null);
    const formatStartDate = startDate
      ? moment(startDate).format("DD-MM-YYYY")
      : "";
    const formatEndDate = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
  
    const { register, setValue, handleSubmit } = useForm({
      defaultValues: {
        search: filters.search,
      },
    });
     const handleIndustryChange = (selected) => {
    setIsIndustry(selected);
    setIsCompany(null);
  };
    const ResetFileter = () => {
    setIsCompany(null);
    setIsIndustry(null);
    setDateRange([null, null]);
    setSortConfig({ column: "", order: "" });
    setCurrentPage(1);

    setFilters({
      search: "",
      start_date: "",
      end_date: "",
      status: "",
      companyId: "",
      industryId: "",
    });

    navigate("/billing/invoice-list");
  };
  const OrderHistoryColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "80px",
    },
    // {
    //     name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
    //     selector: row => row.action,
    //     cell: row => <ActionCell row={row} />,
    //     width: '55px',
    //      center: true,
    // },
    {
      name: <H4>User Name</H4>,
      selector: (row) => row.AccountName,
      sortable: true,
    },
     {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.AccountName,
      sortable: true,
    },
     {
      name: <H4>Company Name</H4>,
      selector: (row) => row.AccountName,
      sortable: true,
    },
    {
      name: <H4>Packages</H4>,
      selector: (row) => row.OpeningBalance,
      sortable: true,
    },
    {
      name: <H4>Expiry Date</H4>,
      selector: (row) => row.BankName,
      sortable: true,
    },
    {
      name: <H4>Plan Type</H4>,
      selector: (row) => row.Bankno,
      sortable: true,
    },
  ];

   return (
    <Fragment>
      {/* {loading && <Transparentspinner />} */}
      <Breadcrumbs
        mainTitle="Expired Subscriptions"
        parent="Report"
        title="Expired Subscriptions"
      />
      <Card>
        <CardHeader>
          <H3>Expired Subscriptions List</H3>
        </CardHeader>
                <Form
            className="needs-validation"
            noValidate
            // onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
              <SearchFilter
                searchValue={filters.search}
                onSearchChange={(val) =>
                  setFilters((prev) => ({ ...prev, search: val }))
                }
              />
              <Col sm="12" md="5" lg="2" className="form-element">
                <div style={{ position: "relative", zIndex: 2 }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    popperPlacement="bottom"
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                  />
                </div>
              </Col>
              <Col sm="12" md="5" lg="3" className="form-element">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  selectedIndustry={filters.industryId}
                  setIsIndustry={handleIndustryChange}
                />
              </Col>

              <Col sm="12" md="5" lg="3" className="form-element">
                <CompanyFilter
                  IsCompany={isCompany}
                  setIsCompany={setIsCompany}
                  industryId={isIndustry?.value}
                />
              </Col>
              <Col sm="12" md="5" lg="2" className="form-element">
                <select
                  className="form-select"
                  ref={isStatus}
                  {...register("status")}
                >
                  <option value="">{PaymentStatus}</option>
                  {invoicePaymentOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm="12" md="5" lg="1" className="custom-filtrs">
                <Btn attrBtn={{ color: "primary" }} type="submit">
                  {Filter}
                </Btn>
              </Col>
              <Col sm="12" md="5" lg="1" className="">
                <button
                  type="button"
                  className="btn btn-primary mb-2 ms-2"
                  onClick={ResetFileter}
                >
                  Reset
                </button>
              </Col>
            </Row>
          </Form>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={OrderHistoryColumns}
              data={[{}]}
              pagination
              customStyles={{
                rows: {
                  style: {
                    display: "none",
                  },
                },
              }}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ExpiredSubscriptions;
